import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InfoComponent {}
